import { GameId } from '@common'
import { ProductContent } from '@common/models/product'
import dynamic from 'next/dynamic'

import { useTranslatable } from '@/localization/useTranslatable'

import { ImageWithFallback } from './ImageWithFallback'

const AnimatedImageWithFallbackNoSSR = dynamic<{
  animationSrc: string
  fallbackImage: string
  safariAnimationSrc?: string | undefined
}>(() => import('../assetRendering/AnimatedImageWithFallback').then((mod) => mod.AnimatedImageWithFallback), {
  ssr: false,
})

type DisplayAssetProps = {
  content: ProductContent
  preferAnimated?: boolean
  gameId: GameId
}

export const DisplayAsset = ({ content, preferAnimated, gameId }: DisplayAssetProps) => {
  const defaultImage = content.product.assets.still
  const translatable = useTranslatable()
  const title = translatable(content.product.title)

  if (preferAnimated && content.product.assets.animated && defaultImage) {
    return (
      <AnimatedImageWithFallbackNoSSR
        animationSrc={content.product.assets.animated?.path}
        fallbackImage={defaultImage.path}
        safariAnimationSrc={content.product.assets.animatedSafari?.path}
      />
    )
  }

  if (!defaultImage) {
    console.warn('No managed default image found for product, falling back', content.product.id)
    return <ImageWithFallback productImage={`/images/${gameId}/assets/${content.product.id}.png`} title={title} />
  }

  return <ImageWithFallback productImage={defaultImage.path} title={title} />
}
